import React from "react";
import * as Icon from "react-bootstrap-icons/dist/index";
import * as Utils from "../../inc/Utils";
import {Link, NavLink} from "react-router-dom/dist/index";
import Role from "../../inc/Role";
import toast, { Toaster } from 'react-hot-toast';
import Pagination from "react-js-pagination";
import {Config} from '../../Config'
import {CopyToClipboard} from "react-copy-to-clipboard";
import Select from 'react-select'

export default function LeadFormCampaign() {
    const roles = new Role();
    //region search
    let btnTextDefault = 'ค้นหา';
    let btnTextLoading = 'กำลังค้นหา..';
    let [showSearch, setShowSearch] = React.useState(false);
    let [itemPerpage, setItemPerpage] = React.useState(10);
    let [countAllItem, setCountAllItem] = React.useState(0);
    let [activePage, setActivePage] = React.useState(1);
    let [totalPage, setTotalPage] = React.useState(0);
    let [sortField, setSortField] = React.useState(null);
    let [sortType, setSortType] = React.useState(null);
    let [checkedIds, setCheckedIds] = React.useState([]);
    let [agency, setAgency] = React.useState('');
    let [users, setUsers] = React.useState('');
    let [userId, setUserId] = React.useState(null);

    const onSearch = (e) => {
        e.preventDefault();
        getData({
            createdBy: roles.permissionId === Utils.SUPER_ADMIN_ID ? (userId ? userId.id : null) : (userId ? userId.id : null),
            agencyId : roles.permissionId === Utils.SUPER_ADMIN_ID  ? null : agency[0].slug,
            sortField : e.target.elements.sortField.value,
            sortType : e.target.elements.sortType.value
        });
        setSortField(e.target.elements.sortField.value);
        setSortType(e.target.elements.sortType.value);
    };
    const onSearchReset = () => {
        setSortField('createdAt');
        setSortType('DESC');
        setActivePage(0);
        setUserId(null);
        getData({
            createdBy: null,
            agencyId : roles.permissionId === Utils.SUPER_ADMIN_ID  ? null : agency[0].slug,
            sortField: 'createdAt',
            sortType: 'DESC',
            activePage: 1
        });
    };
    const onChangeSortField = (Id) => setSortField(Id);
    const onChangeSortType = (Id) => setSortType(Id);
    const onPageChange = (pageNum) => {
        setActivePage(pageNum);
        getData({
            createdBy: roles.permissionId === Utils.SUPER_ADMIN_ID ? (userId ? userId.id : null) : (userId ? userId.id : null),
            setAgencyId : roles.permissionId === Utils.SUPER_ADMIN_ID  ? null : agency[0].slug,
            sortField: sortField ?? null,
            sortType: sortType ?? null,
            activePage: pageNum,
        });
    };
    //endregion

    let [isLoading, setLoading] = React.useState(false);
    let [data, setData] = React.useState('');

    React.useEffect(() => {
        (async function() {
            try {
                const resUsers = await getUsers();
                setUsers(resUsers);
                const resAgency = await Utils.getAgencySlug({agencyId: roles.agencyId});
                setAgency(resAgency);
                getData({
                    createdBy: roles.permissionId === Utils.SUPER_ADMIN_ID ? (userId ? userId.id : null) : (userId ? userId.id : null),
                    agencyId : roles.permissionId === Utils.SUPER_ADMIN_ID  ? null : resAgency[0].slug,
                    sortField: 'createdAt',
                    sortType: 'DESC'
                });
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    const getData = (params) => {
        setLoading(true);
        if(params.itemPerpage) {
            itemPerpage = params.itemPerpage;
        }
        fetch(Config.url.API_URL +'/api/leadFormCampaign/listing', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                agencyId: params.agencyId,
                sortField: params.sortField ?? 'createdAt',
                sortType: params.sortType ?? 'DESC',
                itemPerpage: itemPerpage,
                startItem: params.activePage > 1 ? (params.activePage*itemPerpage)-itemPerpage : 0,
                createdBy: params.createdBy
            })
        }).then(response => {
            setLoading(false);
            if(response.ok) {
                return response.json();
            }
            else {
                return response.json().then(err => Promise.reject(err));
            }
        }).then(result => {
            setCountAllItem(result.count);
            setTotalPage(result.count > 0 ? (result.count / itemPerpage) : 1);
            setData(result.rows);
        }).catch(err => {
            toast.error(err.message);
        });
    };

    const onChangeItemPerpage = (e) => {
        setItemPerpage(e.target.value);
        setActivePage(1);
        getData({
            agencyId : roles.permissionId === Utils.SUPER_ADMIN_ID  ? null : agency[0].slug,
            sortField: 'createdAt',
            sortType: 'DESC',
            activePage: 1,
            itemPerpage: e.target.value
        });
    };

    const onCopyFullUrl = () => {
        toast.success("คัดลอก Full URL แล้ว", {autoClose: 1000});
    };

    const onCheckAll = (isChecked) => {
        if(data.length) {
            data.map((row, index) => {
                let chkSourceId = 'checkId' + row.id;
                if(document.getElementById(chkSourceId)) {
                    document.getElementById(chkSourceId).checked = isChecked;
                }
            });
            onCheckedItem();
        }
    };

    const onCheckedItem = () => {
        let ids = [];
        if(data.length) {
            data.map(row => {
                let chkSourceId = 'checkId' + row.id;
                if(document.getElementById(chkSourceId) && document.getElementById(chkSourceId).checked) {
                    ids.push(row.id);
                }
            });
            setCheckedIds(ids);
        }
    };

    const onChangeUsers = (obj) => {
        setUserId(obj);
    };
    async function getUsers() {
        const response = await fetch(Config.url.API_URL +'/api/user/listingName', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                agencyId: roles.permissionId === Utils.SUPER_ADMIN_ID ? null : roles.agencyId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <main><Toaster position="bottom-right" />
            <div className="row table-toolbar mb-2">
                <div className="col-4 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Lead Form Campaign</div>
                    <span className="ms-1">/</span> <span className="text-muted">Listing</span>
                </div>
                <div className="col-8 text-end align-self-center toolbars">
                    {roles.isCreate(Utils.MENU_LEAD_FORM_PROJECT) ? (
                        <NavLink className="btn btn-sm btn-primary" to='/leadFormCampaign/create'><span><Icon.PlusLg/> Create</span></NavLink>
                    ) : ''}
                </div>
            </div>
            {isLoading ? (<span className="spinner-grow spinner-grow-sm"></span>) :
            <>
                <div className="bg-light border rounded my-2">
                    <button type="button" className="btn btn-light w-100 text-start" onClick={() => {setShowSearch(!showSearch)}}><Icon.Search/> ค้นหา | เรียงลำดับ</button>
                    <div className={showSearch ? 'd-block p-3':'d-none'}>
                        <form className="row g-3" onSubmit={onSearch} onReset={onSearchReset}>
                            <div className="col-12 col-sm-6">
                                <label htmlFor="createdBy" className="form-label">Created By</label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    options={users}
                                    onChange={(event) => onChangeUsers(event)}
                                    defaultValue={userId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.contact}`}
                                />
                            </div>
                            <div className="col-12 col-sm-6">
                                <label htmlFor="sortField" className="form-label">เรียงลำดับ</label>
                                <div className="row">
                                    <div className="col-8">
                                        <select className="form-select" id="sortField" onChange={(event) => onChangeSortField(event.target.value)} value={sortField ?? ''}>
                                            <option value="createdAt">Create At</option>
                                            <option value="campaignId">Campaign Id</option>
                                            <option value="createdBy">Created By</option>
                                        </select>
                                    </div>
                                    <div className="col-4">
                                        <select className="form-select" id="sortType" onChange={(event) => onChangeSortType(event.target.value)} value={sortType ?? ''}>
                                            <option value="DESC">DESC</option>
                                            <option value="ASC">ASC</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <button type="submit" className="btn btn-primary">{isLoading ? btnTextLoading : btnTextDefault}</button>
                                <button type="reset" className="btn btn-light border ms-2">รีเซ็ต</button>
                            </div>
                        </form>
                    </div>
                </div>
                {data.length <= 0 ? (<p>ไม่พบข้อมูล</p>) :
                    <>
                        <div className="table-container shadow">
                        <table className="table table-striped">
                            <thead>
                            <tr>
                                <th className="w50 text-center">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" id="checkAll" onChange={e => {onCheckAll(e.target.checked)}} />
                                        <label className="form-check-label" htmlFor="checkAll"></label>
                                    </div>
                                </th>
                                <th className="w50">ID</th>
                                <th className="w150">Campaign Id</th>
                                <th className="w150">Agency</th>
                                <th>Params</th>
                                <th className="w70 text-center">Copy</th>
                                <th className="w70 text-center">Duplicate</th>
                                <th className="w100 text-center">CreatedBy</th>
                                <th className="w100 text-center">Created Date</th>
                                {roles.isDelete(Utils.MENU_LEAD_FORM_PROJECT) ? (
                                    <th className="w70 text-center">ลบ</th>
                                ) : ''}
                            </tr>
                            </thead>
                            <tbody>
                            {data.map((row, index) => {
                                let date = new Date(row.createdAt);
                                let newcreatedAt = date.getDate() + '' + Utils.monthNames[date.getMonth()] + '' + date.getFullYear();

                                let params = row.campaignId + '_' + row.agencyId + '_' + row.campaignName + '_' + newcreatedAt +  (row.freeForm ? '_' + row.freeForm:'') + '_[ST]';
                                return (
                                    <tr key={index} id={"rowId" + row.id}>
                                        <th className="text-center">
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" id={"checkId"+row.id} value={row.id} onClick={() => onCheckedItem()} />
                                                <label className="form-check-label" htmlFor={"checkId"+row.id} ></label>
                                            </div>
                                        </th>
                                        <td>{row.id}</td>
                                        <td>{row.campaignId}</td>
                                        <td>{row.agencyId}</td>
                                        <td><div className="noselect-url">{params}</div></td>
                                        <td className="text-center">
                                            <CopyToClipboard text={params} onCopy={() => {onCopyFullUrl()}}>
                                                <button type="button" className={"btn btn-sm btn-light" + (params ? '':' d-none')}><Icon.Files /></button>
                                            </CopyToClipboard>
                                        </td>
                                        <td className="text-center">
                                            {roles.isCreate(Utils.MENU_LEAD_FORM_PROJECT) ? (
                                                <Link className="btn btn-sm btn-light mx-1" to={'/leadFormCampaign/create/' + Utils.encodeItem({id: row.id,  createdAt: row.createdAt})}><Icon.Send/></Link>
                                            ) : ''}
                                        </td>
                                        <td className="text-center small">{row.user.contact}</td>
                                        <td className="text-center">{Utils.dateTime(row.createdAt)}</td>
                                        {roles.isDelete(Utils.MENU_LEAD_FORM_PROJECT) ? (
                                            <td className="text-center"><button className="btn btn-sm btn-light mx-1" onClick={() => Utils.deleteItem('leadFormCampaign', row.id, row.params)}><Icon.Trash/></button></td>
                                        ) : ''}
                                    </tr>
                                );
                            })
                            }
                            </tbody>
                        </table>
                        </div>
                        <div className="row mt-3">
                            <div className="col-12 col-sm-4 mt-2 mt-sm-0 text-end align-self-center">
                                <select className="form-select w100" id="itemPerpage" onChange={(e) => onChangeItemPerpage(e)} value={itemPerpage}>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                            <div className="col-12 col-sm-8">
                                <div className={totalPage > 1 ? 'my-3':'d-none'}>
                                    <Pagination
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        innerClass="pagination justify-content-sm-end"
                                        activePage={activePage}
                                        itemsCountPerPage={itemPerpage}
                                        totalItemsCount={countAllItem}
                                        pageRangeDisplayed={5}
                                        onChange={(pageNum) => onPageChange(pageNum)}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                }
            </>
            }
        </main>
    );
} 